import { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import "./style.scss"

class Dot extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    focus: PropTypes.func.isRequired,
    blur: PropTypes.func.isRequired,
    focused: PropTypes.string,
    color: PropTypes.string.isRequired,
    y: PropTypes.number.isRequired,
    onClick: PropTypes.func,
  }

  onEnter = () => {
    const { id, focus } = this.props
    focus(id)
  }

  onLeave = () => {
    const { blur } = this.props
    blur()
  }

  render() {
    const { color, y, focused, id, onClick } = this.props
    return <g
      onMouseEnter={this.onEnter}
      onMouseLeave={this.onLeave}
      onClick={onClick ? (e) => onClick(e, id) : undefined}
      transform={`translate(0,${y})`}
      className={classNames(
        "dot focus-enabled",
        focused && focused === id && "visible",
        focused && focused !== id && "hidden",
      )}
      style={onClick ? { cursor: "pointer" } : undefined}
    >
      {/* Transparent, oversized hit area so the dot is easy to click/hover even when points are
          densely packed (intraday) — the visible circles stay small. */}
      <circle r="11" cx="0" cy="0" fill="transparent" style={{ pointerEvents: "all" }} />
      <circle r="4" cx="0" cy="0" style={{ fill: color }} />
      <circle r="8" cx="0" cy="0" style={{ fill: color }} className="selected" />
    </g>
  }
}

export default Dot
